import { emailIpWarmingAppGroupIdPlan } from "../emailIpWarmingAppGroupIdPlan/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const emailIpWarmingAppGroupIdLaunchCacheKeys: AllRouteEndpoints[] = [emailIpWarmingAppGroupIdPlan];
